import React from 'react';

const RetailAvailability = () => {
    const stores = [
        {
            name: 'Walgreens',
            logo: 'https://sinoclear.net/pm/images/X-Walgreens_2020_primary_logo.svg'
        },
        {
            name: 'Walmart',
            logo: 'https://sinoclear.net/pm/images/X-Walmart_logo.svg'
        },
        {
            name: 'GNC',
            logo: 'https://sinoclear.net/pm/images/x-gnc-live-well-2.svg'
        },
        {
            name: 'CVS',
            logo: 'https://sinoclear.net/pm/images/X-CVS_Pharmacy_Alt_Logo.svg'
        }
    ];

    return (
        <div className="w-full bg-white py-12">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-8">
                    <div className="flex flex-wrap items-center justify-center gap-8">
                        {stores.map((store, index) => (
                            <div key={index} className="relative w-[130px] h-[60px]">
                                <img
                                    src={store.logo}
                                    alt={`Not available at ${store.name}`}
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="relative w-[24px] h-[24px]">
                            <img
                                src="https://sinoclear.net/pm/images/check-mark.svg"
                                alt="Checkmark"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <div className="text-[#1B365D] font-bold">
                            Only Available<br />
                            On This Page!
                        </div>
                    </div>
                </div>
                <div className="mt-6 max-w-4xl mx-auto text-start">
                    <p className="text-gray-900">
                        <span className="font-bold">Sinoclear is not sold in stores or elsewhere online and as a custom proprietary product, it will never be.</span>
                        {' '}It is only available for purchase on this page ONLY.{' '}
                        <span className="font-bold">This is the very last time</span>
                        {' '}you'll be able to claim this new customer VIP discount. Select your package and claim your one-time savings now. Protect your lungs now and well into the future. Do it for yourself, and do it for your family.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RetailAvailability;

